import { buildWebITData } from "@/data/buildWebIT.data";
import { contactData } from "@/data/contact-info.data";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const WhatsappIcon = () => {
  return (
    <Link
      href={buildWebITData.whatsappLink}
      area-label="WhatsApp"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* <FaWhatsapp
                    size={24}
                    className="text-white hover:underline transition-colors duration-300"
                  /> */}
      <Image
        src={contactData[0].src}
        alt="WhatsApp Icon"
        width={27}
        height={27}
      />
    </Link>
  );
};

export default WhatsappIcon;
